import React from 'react'
import { useFilters } from '../../context/FiltersContext'
import { capitalizeFirstLetter } from '../../utils'
import { ToggleAll } from '../ToggleAll'
import { Filter } from './Filter'
import { Clearfix } from '../Clearfix'
import classnames from 'classnames'

interface Props {
  category: 'range' | 'seatType'
}

export const FilterCategoryContent: React.FC<Props> = ({ category }) => {
  const { activeCategories, filters, toggleCategory } = useFilters()

  const categoryFilters = filters[category]

  const className = classnames('refineby-filters', `__${category}`, {
    __active: activeCategories.has(category),
  })

  return (
    <div className={className}>
      <p
        data-type={category}
        onClick={() => toggleCategory(category)}
        className="refineby-subtitle"
      >
        {capitalizeFirstLetter(category.split(/(?=[A-Z])/).join(' '))}
      </p>

      <div data-type={category} className="refineby-filterwrap">
        {category === 'range' && <ToggleAll category="range" />}
        <ul>
          {categoryFilters.map(filter => (
            <Filter key={filter.id} filter={filter} />
          ))}
        </ul>
        <Clearfix />
      </div>
    </div>
  )
}
